import { SSRGlobal } from "../qecomps/Context";
import Img from "../qecomps/Img";

export default (props) => {
  let z = SSRGlobal()
  return <>
    <div id="gototop" style={{display:"none", position: "fixed", bottom: "1rem", left: "1rem", zIndex: 50, opacity: 0.5 }}
      // tabIndex={100}
      onClick={() => {
        global.document?.getElementById("wind")?.scrollTo({
          top: 0,
           behavior: 'smooth' // This creates a smooth scrolling effect, omit for instant scroll
        });
      }}>
      <Img className={z.styles.hoverfade} src={global.cdn("/files/gototop.webp")} style={{ width: 50, height: 50 }} />
    </div>
  </>
}